import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import LocalBusinessSchema from "../shared/LocalBusinessSchema";
import SeoManager from "../SeoManager";

export default function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <SeoManager />
      <LocalBusinessSchema />
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
